module.exports = __webpack_public_path__ + "img/old.4476ff4f.png";